<template>
  <div :class="'dropzone ' + variant">
    <div v-if="!uploading" data-toggle="dropzone">
      <slot>
        <div class="inner">
          <i class="icon fa fa-download"/>
          <div><b>Choose a file</b> or drag it here.</div>
        </div>
      </slot>
    </div>
    <div
      v-if="error"
      class="m-3">
      <div class="alert alert-danger">
        <i class="fa fa-exclamation-triangle mr-1"/>
        {{ error }}
      </div>
    </div>
    <div
      v-if="uploading"
      class="inner">
      <p>Uploading...</p>
      <div class="progress">
        <div
          :aria-valuenow="progress"
          :style="`background-color: ${progressBarColor}; width: ${progress}%;`"
          class="progress-bar"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"/>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .dropzone {
    text-align: center;
    cursor: pointer;
    border: 2px dashed #ccc;
    transition: border 0.2s;

    &.custom {
      border: none;
    }

    .inner {
      height: 180px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: opacity 0.2s;
    }

    .icon {
      font-size: 64px;
      margin-bottom: 0.5rem;
    }

    .progress {
      margin-left: 25%;
      margin-right: 25%;
    }

    &.is-dragover {
      border: 2px dashed #111;

      .inner {
        opacity: 0.5;
      }
    }

    &.is-invalid {
      border: 2px dashed #e74c3c;

      .inner {
        color: #e74c3c;
      }
    }

    &.small {
      .icon {
        font-size: 32px;
      }
    }
  }
</style>

<script>
  import $ from 'jquery'
  import plupload from 'plupload'
  import bag from '@/lib/MessageBag'
  import api from '@/api'
  import urls from '@/api/urls'

  export default {
    name: 'Dropzone',
    props: {
      progressBarColor: {
        type: String,
        default: '#111'
      },
      type: {
        type: String,
        default: 'document'
      },
      url: {
        type: String,
        default: null
      },
      variant: {
        type: String,
        default: null
      }
    },

    data () {
      return {
        error: false,
        uploading: false,
        progress: 0
      }
    },

    computed: {
      uploadUrl () {
        return `${api.defaults.baseURL}/${this.type === 'image' ? urls.upload.image() : urls.upload.document()}`
      },

      uploadHeaders () {
        return api.defaults.headers.common
      }
    },

    mounted () {
      let vm = this
      let $container = $(this.$el)
      let $dropZone = $container.find('[data-toggle="dropzone"]')

      $container
        .on('dragover dragenter', () => {
          $container.addClass('is-dragover')
        })
        .on('dragleave dragend drop', () => {
          $container.removeClass('is-dragover')
        })

      const uploader = new plupload.Uploader({
        container: $container[0],
        drop_element: $dropZone[0],
        browse_button: $dropZone[0],
        url: this.uploadUrl,
        headers: this.uploadHeaders,
        init: {
          BeforeUpload (up, file) {
            up.settings.url = vm.uploadUrl
          },

          FilesAdded (up, files) {
            vm.error = false
            uploader.start()
            vm.uploading = true
          },

          UploadProgress (up, file) {
            vm.progress = file.percent
          },

          FileUploaded (up, file, object) {
            setTimeout(() => {
              vm.progress = 0
              vm.uploading = false
              // wait.uploaded()
              let response = JSON.parse(object.response)
              vm.$emit('input', response)
              vm.$emit('uploaded', response)
            }, 2000)
          },

          Error (uploader, error) {
            vm.uploading = false
            if (error.status === 422) {
              vm.error = bag(error.response).first()
            }
            // wait.oops()
          }
        }
      })

      uploader.init()
    }
  }
</script>
